<template>
    <div>
        <info-item
            :label="resource('DmVisualizer_ChangeInfo_OpeningHours')"
            :isEnabled="isEnabled"
            @set-enabled="$emit('set-enabled', $event)"
        >
            <div v-if="daysReady" class="row">
                <div class="col-6">
                    <info-text-input
                        v-for="day in daysLeft"
                        :key="day.key"
                        :label="day.key"
                        :placeholder="day.placeholder"
                        :isEnabled="isEnabled"
                        :value="day.value"
                        @input="emitFieldUpdate(day.name, $event)"
                    >

                    </info-text-input>
                </div>
                <div class="col-6">
                    <info-text-input
                        v-for="day in daysRight"
                        :key="day.key"
                        :label="day.key"
                        :placeholder="day.placeholder"
                        :isEnabled="isEnabled"
                        v-bind:="day.value"
                        @input="emitFieldUpdate(day.name, $event)"
                    >
                    </info-text-input>
                </div>
            </div>
        </info-item>
    </div>
</template>

<script>

//mixins
import resourceMixin from '../../../../Util/Mixins/resources';

//Components
import InfoItem from './InfoItem.vue';
import InfoTextInput from './Components/InfoTextInput.vue';

export default {
    name: 'info-opening-hours',
    mixins: [resourceMixin],
    components: {
        InfoItem,
        InfoTextInput
    },
    created() {
        this.days = [
            {name: 'monday', key: this.resource('Day_Monday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_1300_1800')},
            {name: 'tuesday', key: this.resource('Day_Tuesday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_0930_1800')},
            {name: 'wednesday', key: this.resource('Day_Wednesday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_0930_1800')},
            {name: 'thursday', key: this.resource('Day_Thursday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_0930_1800')},
            {name: 'friday', key: this.resource('Day_Friday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_0930_2100')},
            {name: 'saturday', key: this.resource('Day_Saturday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_0930_1800')},
            {name: 'sunday', key: this.resource('Day_Sunday'), placeholder: this.resource('DmVisualizer_ChangeInfo_Placeholder_1200_1800')}
        ];
    },
    methods: {
        emitFieldUpdate(name, value){
            this.$emit(`update:${name}`, value);
        }
    },
    computed: {
        daysReady() {
            return this.days != [];
        },
        daysLeft() {
            return this.days.slice(0,4);
        },
        daysRight() {
            return this.days.slice(4,7);
        }
    },
    data() {
        return {
            days: []
        };
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
